import { colors, fonts, radius, sizes, space } from '../../theme/tokens'

// The same-day WhatsApp offer under the day chips (components/same-day-offer).
export const styles = theme => ({
  offer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: space(8),
    margin: `${space(8)}px 0 0`,
    padding: `${space(8)}px ${space(12)}px`,
    border: `1px solid ${colors.line}`,
    borderRadius: radius.control,
    background: colors.paper,
    fontFamily: fonts.body
  },
  text: { fontSize: 13, lineHeight: '18px', color: colors.ink, flex: '1 1 180px' },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: sizes.tapMin,
    padding: `0 ${space(12)}px`,
    borderRadius: radius.control,
    background: colors.whatsapp,
    color: colors.onAccent,
    fontSize: 14,
    fontWeight: 600,
    textDecoration: 'none',
    whiteSpace: 'nowrap'
  }
})
